if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();

      this.selectEl = this.querySelector('select');

      this.createCustomSelect();

      this.dropdown = this.querySelector('.js-dropdown');
      this.btnToggleDropdown = this.querySelector('.js-btn-dropdown');
      this.listOptions = this.querySelector('.js-list-options');
      this.isExpanded = false;

      this.setBtnWidth();

      window.addEventListener('DOMContentLoaded', () => {
        this.setBtnWidth();
      });

      window.addEventListener('shopify:section:load', () => {
        clearTimeout(this.loadTimeout);

        this.loadTimeout = setTimeout(() => {
          this.setBtnWidth();
        }, 300);
      });

      window.addEventListener('resize', () => {
        if (DeviceDetector.isMobile()) {
          return;
        }

        const isWidthUnchanged =
          +this.btnToggleDropdown.style.width.replace('px', '') ===
          this.dropdown.clientWidth;

        if (isWidthUnchanged) {
          return;
        }

        this.btnToggleDropdown.style.width = `${this.dropdown.clientWidth}px`;
      });

      this.btnToggleDropdown.addEventListener('click', e => {
        e.preventDefault();

        const isExpanded = this.classList.contains('is-expanded');

        if (isExpanded) {
          this.hideDropdown();

          return;
        }

        this.showDropdown();
      });

      this.btnToggleDropdown.addEventListener('keydown', e => {
        if (e.key.includes('Arrow')) {
          e.preventDefault();

          const isArrowRight = e.key.includes('Right');
          const isHorizontalArrow =
            e.key.includes('Left') || isArrowRight;

          if (this.isExpanded && isHorizontalArrow) {
            return;
          }

          const isNextKey = isArrowRight || e.key.includes('Down');

          const btnOptionSelected = this.listOptions.querySelector(
            '.js-btn-option.is-selected'
          );
          const selectedOptionParent =
            btnOptionSelected.parentElement;
          let prevNextBtnOption = isNextKey
            ? selectedOptionParent.nextElementSibling
                ?.firstElementChild
            : selectedOptionParent.previousElementSibling
                ?.firstElementChild;

          if (!prevNextBtnOption) {
            prevNextBtnOption = isNextKey
              ? this.listOptions.firstElementChild.firstElementChild
              : this.listOptions.lastElementChild.firstElementChild;
          }

          this.changeSelectedOption(
            btnOptionSelected,
            prevNextBtnOption
          );

          return;
        }

        if (!this.isExpanded) {
          return;
        }

        const isEscape = e.key === 'Escape';
        const isTab = e.key === 'Tab';

        if (!isEscape && !isTab) {
          return;
        }

        e.preventDefault();

        this.hideDropdown();
      });

      this.listOptions.addEventListener('click', e => {
        const isBtnOption =
          e.target.classList.contains('js-btn-option');

        if (!isBtnOption) {
          return;
        }

        e.preventDefault();

        const btnOption = e.target;
        const isSelected =
          btnOption.classList.contains('is-selected');

        this.hideDropdown();

        if (isSelected) {
          return;
        }

        this.changeSelectedOption(undefined, btnOption);
      });

      document.addEventListener('click', e => {
        if (!this.isExpanded) {
          return;
        }

        const isThisSelect =
          e.target.closest('custom-select') === this;

        if (isThisSelect) {
          return;
        }

        this.hideDropdown();
      });
    }

    setBtnWidth() {
      this.btnToggleDropdown.style.width = `${this.dropdown.clientWidth}px`;
    }

    createCustomSelect() {
      const options = this.querySelectorAll('option');
      // const selectedOption = this.selectEl.querySelector(
      //   'option[selected="selected"]'
      // );
      // let optionsMarkup = '';

      const selectedOption = this.selectEl.querySelector(
        'option[selected="selected"]'
      );

      // MERGE: Desktop/Mobile Filter & Sort Redesign
      // Allows specific custom-select instances to show the currently selected
      // sort option instead of always displaying the static "Sort by" label.
      this.showSelectedOption =
        this.dataset.showSelectedOption === 'true';

      let optionsMarkup = '';


      options.forEach(option => {
        const optionMarkup = `
          <li class="custom-select__item">
            <button
              type="button"
              class="custom-select__option button-reset js-btn-option ${
                option.selected ? 'is-selected' : ''
              }"
              data-value="${option.value}"
              tabindex="-1"
              aria-selected="${option.selected}"
            >${option.textContent}</button>
          </li>
        `;

        optionsMarkup += optionMarkup;
      });
      const sortLabel = this.dataset.sortLabel || 'Sort by';
      // MERGE: Desktop/Mobile Filter & Sort Redesign
      // The mobile filter sheet displays the active sort option as the field value
      // and keeps a chevron beside it. Other custom selects keep the original label.
      const buttonContent = this.showSelectedOption
        ? `<span class="custom-select__selected-option">${selectedOption.textContent}</span><span class="custom-select__chevron" aria-hidden="true"></span>`
        : sortLabel;

      const markup = `
        <div class="custom-select__wrapper">
          <button
            type="button"
            class="custom-select__btn button-reset focus-inset js-btn-dropdown"
            aria-controls="${this.dataset.dropdownId}"
            aria-expanded="false"
            aria-label="${sortLabel}"
          >${buttonContent}</button>
          <div class="custom-select__dropdown js-dropdown" id="${this.dataset.dropdownId}">
            <ul class="custom-select__items list-unstyled js-list-options">
              ${optionsMarkup}
            </ul>
          </div>
        </div>
      `;

      this.insertAdjacentHTML('afterbegin', markup);
      this.dataset.value = selectedOption.value;
    }

    changeSelectedOption(
      selectedOption = this.listOptions.querySelector(
        '.js-btn-option.is-selected'
      ),
      newSelectedOption
    ) {
      // this.btnToggleDropdown.textContent =
      //   newSelectedOption.textContent;

      // MERGE: Desktop/Mobile Filter & Sort Redesign
      // When the mobile selected-value markup exists, update only its text.
      // Updating the whole button with textContent would remove the chevron.
      const selectedOptionLabel = this.btnToggleDropdown.querySelector(
        '.custom-select__selected-option'
      );

      if (selectedOptionLabel) {
        selectedOptionLabel.textContent = newSelectedOption.textContent;
      } else {
        this.btnToggleDropdown.textContent = newSelectedOption.textContent;
      }
      this.dataset.value = newSelectedOption.dataset.value;

      newSelectedOption.classList.add('is-selected');
      newSelectedOption.setAttribute('aria-selected', true);

      selectedOption.classList.remove('is-selected');
      selectedOption.setAttribute('aria-selected', false);

      // const nativeSelectedOption = this.selectEl.querySelector(
      //   'option[selected="selected"]'
      // );
      // const newNativeSelectedOption = this.selectEl.querySelector(
      //   `option[value="${this.dataset.value}"]`
      // );

      // nativeSelectedOption.removeAttribute('selected');
      // newNativeSelectedOption.setAttribute('selected', 'selected');

      // // Trigger input event

      const newNativeSelectedOption = this.selectEl.querySelector(
        `option[value="${this.dataset.value}"]`
      );

      // MERGE: Filter & Sort AJAX Synchronization
      // Keep the native select's live value and selected state synchronized before
      // triggering the existing input event. Shopify facet FormData reads the live
      // select value when building the AJAX filter/sort request.
      this.selectEl.value = this.dataset.value;

      Array.from(this.selectEl.options).forEach(option => {
        const isSelected = option === newNativeSelectedOption;

        option.selected = isSelected;
        option.toggleAttribute('selected', isSelected);
      });

      // Trigger the existing facet AJAX submission after the native select is synced.

      const inputEvent = new Event('input', { bubbles: true });

      this.selectEl.dispatchEvent(inputEvent);
    }

    showDropdown() {
      this.isExpanded = true;
      this.classList.add('is-expanded');
      this.btnToggleDropdown.setAttribute('aria-expanded', true);
    }

    hideDropdown() {
      this.isExpanded = false;
      this.classList.remove('is-expanded');
      this.btnToggleDropdown.setAttribute('aria-expanded', false);
    }
  }

  customElements.define('custom-select', CustomSelect);
}
